import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { scribeDocumentBase } from './ScribePropTypes';
import FreeHtmlBanner from './containers/FreeHtmlBanner';
import MiniBanner from './containers/MiniBanner';

export default class MiniBanners extends PureComponent {
  static propTypes = {
    offersLandingPage: PropTypes.shape({
      docNo: PropTypes.number.isRequired,
      docVersionNo: PropTypes.number.isRequired,
      docModel: PropTypes.string.isRequired,
      docTitle: PropTypes.string.isRequired,
      miniBanners: PropTypes.arrayOf(
        PropTypes.shape({
          promotedBanner: PropTypes.shape({
            ...scribeDocumentBase,
            imageSrc: PropTypes.string.isRequired,
            imageAlt: PropTypes.string,
            url: PropTypes.string.isRequired,
          }),
          freeHtmlFile: PropTypes.shape({
            ...scribeDocumentBase,
          }),
        })
      ).isRequired,
    }).isRequired,
  };

  renderMiniBanner = (miniBanner, index) => {
    const { promotedBanner, freeHtmlFile } = miniBanner;
    if (promotedBanner) {
      return this.renderPromotedBanner(promotedBanner, index);
    } else if (freeHtmlFile) {
      return this.renderFreeHtml(freeHtmlFile, index);
    }
    return null;
  };

  renderPromotedBanner = (promotedBanner, index) => {
    const { offersLandingPage } = this.props;
    return (
      <li key={index} className="promotion">
        <MiniBanner parentContainer={offersLandingPage} {...promotedBanner} />
      </li>
    );
  };

  renderFreeHtml = (freeHtmlFile, index) => {
    const { docNo, docVersionNo, docModel, docTitle } = this.props.offersLandingPage;
    const parentContainer = { docNo, docVersionNo, docModel, docTitle };
    return (
      <li key={index} className="promotion">
        <FreeHtmlBanner
          {...freeHtmlFile}
          parentContainer={parentContainer}
        />
      </li>
    );
  };

  render() {
    return (
      <ul className="miniBanners">
        {this.props.offersLandingPage.miniBanners.map((miniBanner, index) => this.renderMiniBanner(miniBanner, index))}
      </ul>
    );
  }
}

